import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { Title } from '@angular/platform-browser';
import {
    DatiqRateTimeInterval,
    IDatiqRateDateRange,
} from '@dat/datiq-core/models';

/**
 * TODO: Move all functions and methods related to the RateLane to the utils functions in DatiqRateLane Utils Library
 */
@Injectable({
    providedIn: 'root',
})
export class DatiqUtilsService {
    constructor(private _title: Title) {}

    getStartOfFutureWeek(weeks: number): Date {
        return DateTime.now().plus({ weeks: weeks }).startOf('week').toJSDate();
    }

    getFutureDays(days: number): Date {
        return DateTime.now().plus({ days: days }).toJSDate();
    }

    getFutureDateRange(
        start: Date,
        interval: DatiqRateTimeInterval,
        duration: number
    ): IDatiqRateDateRange {
        return {
            start,
            end: DateTime.fromJSDate(start)
                .plus({ [interval]: duration })
                .toJSDate(),
        };
    }

    getPastDateRange(
        start: Date,
        interval: DatiqRateTimeInterval,
        duration: number
    ): IDatiqRateDateRange {
        return {
            start,
            end: DateTime.fromJSDate(start)
                .minus({ [interval]: duration })
                .toJSDate(),
        };
    }

    /**
     * Sets a passed in date to the beginning of the day
     * @param currentDate - the current date to set
     * @returns Sets the date passed into the start of the day
     */
    setDateToBeginning(currentDate: Date | string): Date {
        const date: Date = this.getDateTime(currentDate).toJSDate()
        return date;
    }

    /**
     * Passes in a UTC Date and sets it to the local time
     * @param utcDate - the date at UTC time
     * @returns a date at local time
     */
    mapUTCToLocalDate(utcDate: Date | string): Date {
        const localDate =
            typeof utcDate == 'string'
                ? DateTime.fromISO(utcDate, { zone: 'utc' })
                      .toLocal()
                      .toJSDate()
                : DateTime.fromJSDate(utcDate, { zone: 'utc' })
                      .toLocal()
                      .toJSDate();

        return localDate;
    }

    getDateTime(date: string | Date): DateTime {
        return typeof date === 'string'
            ? DateTime.fromISO(date)
            : DateTime.fromJSDate(date);
    }

    normalizeDate(date: string): Date {
        const datePart: string = date?.split('T')?.[0];
        return DateTime.fromISO(datePart).toUTC().toJSDate();
    }

    allTrue(results: boolean[]): boolean {
        return results.every((result: boolean): boolean => result);
    }

    allFalse(results: boolean[]): boolean {
        return results.every((result: boolean): boolean => !result);
    }

    atLeastOneTrue(results: boolean[]): boolean {
        return results.some((result: boolean): boolean => result);
    }

    setPageTitle(title: string) {
        this._title.setTitle(title);
    }
}
